export const GET_FAV_EVENT_TEMPLATE = "GET_FAV_EVENT_TEMPLATE";
